import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import contactSagas from '@iso/redux/contacts/saga';
 import mailSagas from '@iso/redux/mail/saga';
import notesSagas from '@iso/redux/notes/saga';
 import ecommerceSaga from '@iso/redux/ecommerce/saga';
import cardsSagas from '@iso/redux/card/saga';
import chatSagas from '@iso/redux/chat/sagas';
 import githubSagas from '@iso/redux/githubSearch/sagas';
import investors from '@iso/redux/investors/sagas';
import scrumBoardSaga from '@iso/redux/scrumBoard/saga';
import profileSaga from '@iso/redux/profile/saga';
 import configSaga from '@iso/redux/configmgmnt/saga';
import userSaga from '@iso/redux/userManagement/saga';
import logSaga from '@iso/redux/log/saga';
import transSaga from'@iso/redux/transactionMgmnt/saga';
export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    contactSagas(),
    mailSagas(),
    notesSagas(),
     ecommerceSaga(),
    cardsSagas(),
     chatSagas(),
     githubSagas(),
     investors(),
    scrumBoardSaga(),
    profileSaga(),
     configSaga(),
    userSaga(),
    logSaga(),
    transSaga()
  ]);
}
